import CodeEnter from './CodeEnter';
CodeEnter.install = function(Vue) {
  Vue.component(CodeEnter.name, CodeEnter);
};

export default CodeEnter;
